import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Transition} from 'semantic-ui-react'
import Slider from "react-slick";
import {Player, ControlBar} from 'video-react';

import {setMenuVisible} from '../actions'
import http from '../utils/http-common'
import {productionBaseUrl, productionVideoUrl} from '../config/const';

import styles from './CoProductionInfo.module.scss'
import './CoProductionInfo.css'
import MenuIconDesktop from '../components/MenuIconDesktop';

class CoProductionInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trailerVideoVisible: false,
            isPageVisible: false,
            language: "",
            production: {
                id: 0,
                name: "",
                year: "",
                selfDefineCategory: "",
                category:{
                    key: ""
                },
                order: '',
                videoPath: "",
                language: "TW",
                description: "",
                awards: [],
                images: []
            },
        }

        this.productionId = props.match.params.productionId;

        this.handleTrailerVideo = this.handleTrailerVideo.bind(this);
        this.closeVideo = this.closeVideo.bind(this);
        this.goBackToProductionList = this.goBackToProductionList.bind(this);
        this.getLanguage = this.getLanguage.bind(this);
    };

    componentDidMount() {
        this.getLanguage();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.production !== this.state.production) {
            setTimeout(() => {
                this.setState({
                    isPageVisible: true,
                });
            }, 300);
        }

        if (prevState.trailerVideoVisible === false && this.state.trailerVideoVisible === true) {
            this.player.load();
            this.player.play();
        }

        if (prevProps.language !== this.props.language) {
            this.getLanguage();
        }

        this.sliderWidth = Math.floor(document.getElementById("content_container").offsetWidth * (569/1280));
        this.sliderHeight = Math.floor(document.getElementById("content_container").offsetHeight * (320/800));
        this.sliderWidthM = Math.floor(document.getElementById("content_container").offsetWidth);
        this.sliderHeightM = 250;
    }

    getLanguage() {
        http.get("/api/v1/productions/"+ this.productionId + "?language=" + localStorage.getItem("language"))
            .then(res=>{
                this.setState({production: res.data});
            })
            .catch(error=>{console.log(error)})
    }

    handleTrailerVideo(e) {
        this.setState({trailerVideoVisible: true});
    };

    closeVideo() {
        this.player.load();
        this.setState({trailerVideoVisible: false});
    }

    goBackToProductionList() {
        this.setState({
            isPageVisible: false
        });
    }

    setStepVisible(index, visible) {
        const steps = [...this.state.steps];
        steps[index] = visible;
        this.setState({steps: steps});
    }

    getSubtitle(categoryKey){
        switch(categoryKey) {
            case 1:
                return "FILM";
                break;
            case 2:
                return "TELEFILEM";
                break;
            case 3:
                return "SHORT FILM";
                break;
            case 4:
                return "Documentary";
                break;
        }
    }

    getLanguageClass = () => {
        switch(this.props.language) {
            case "EN":
                return styles.en;
            default:
                return '';
        }
    }

    render() {
        const sliderSetting = {
            arrows: false,
            dots: true,
            autoplay: true
        }

        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const videoWeb = (vw >= 768) ? productionVideoUrl + this.state.production.videoPath : "";
        const videoMobil = (vw > 768) ? "" : productionVideoUrl + this.state.production.videoPath;

        return (
            <>
                <div className={`${styles.co_production} co_production ${styles.desktop} ${this.getLanguageClass()}`}>

                        <div>
                            <Transition visible={this.state.isPageVisible} animation='fade' duration={2000} onHide={() => {
                                this.props.history.push("/co_production")
                            }}>
                                <MenuIconDesktop color="white" />
                            </Transition>

                            <div className={styles.back_wrapper} onClick={this.goBackToProductionList}>
                                <div className={`arrow left ${styles.arrow}`}></div>
                                <div className={styles.back_word}>BACK</div>
                            </div>

                            <Transition visible={this.state.isPageVisible} animation='fade' duration={2000}>
                            <div className={styles.page}>
                                <div className={styles.page_subtitle}>{this.state.production.year} · FILM</div>
                            </div>
                            </Transition>

                            <Transition visible={this.state.isPageVisible} animation='fade' duration={2000}>
                            <div className={styles.title}>
                                <div className={styles.title_word}>Co-Production</div>
                                <div className={styles.subtitle_block}>
                                    <div className={styles.subtitle_word}>OUTLAND Film Production</div>
                                </div>
                            </div>
                            </Transition>


                            <div className={styles.content}>
                                <Transition visible={this.state.isPageVisible} animation='fade' duration={1000}>
                                <div className={styles.content_overlay}></div>
                                </Transition>

                                <Transition visible={this.state.isPageVisible} animation='fade' duration={2000}>
                                <div className={`production_content_logo ${styles.content_logo}`} style={
                                    {
                                    //     width: this.sliderWidth,
                                    //     height: this.sliderHeight
                                    }
                                }>
                                    <div
                                        className={`${styles.video_player} ${this.state.trailerVideoVisible ? null : 'display_none'}`}>
                                        <div className={`close_button ${styles.close_button}`}
                                             onClick={() => {
                                                 this.closeVideo()
                                             }}>
                                            <div className="left_line">
                                                <div className="right_line"></div>
                                            </div>
                                        </div>
                                        {vw >= 768 ?
                                          <Player preload="none" ref={player => {
                                              this.player = player;
                                          }}>
                                              <source src={videoWeb}/>
                                              <ControlBar autoHide={false}/>
                                          </Player>
                                          : null }
                                    </div>
                                    <div className={styles.slide_container}>
                                        <Slider {...sliderSetting}>
                                            {this.state.production.images.filter(image=>image.apply).filter(image=>image.type==="desktop").map(image=>{
                                                return <div className={styles.content_slide}>
                                                    <div className={styles.img} style={
                                                        {
                                                            backgroundImage: `url("${productionBaseUrl + image.path}"`,
                                                            // width: this.sliderWidth,
                                                            // height: this.sliderHeight
                                                        }
                                                    }></div>
                                                </div>
                                            })}
                                        </Slider>
                                    </div>
                                </div>
                                </Transition>
                                <Transition visible={this.state.isPageVisible} animation='fade' duration={2000}>
                                <div className={styles.content_description}>
                                    <div className={styles.production_content_container}>
                                        <div className={styles.production_content_title} dangerouslySetInnerHTML={{__html: this.state.production.name}}></div>

                                        {this.state.production.videoPath !== null && "" !== this.state.production.videoPath.trim() ?
                                          <div className={styles.production_trailer} onClick={this.handleTrailerVideo}></div>
                                          : null
                                        }

                                        {this.state.production.awards.length > 0 ?
                                        <div className={styles.production_award}>
                                            {this.state.production.awards.map(award => {
                                                return <div><span className={styles.award_icon}></span>{award.content}</div>
                                            })}
                                        </div>
                                          : null }
                                        <div className={styles.production_description} dangerouslySetInnerHTML={{__html: this.state.production.description}}>

                                        </div>
                                    </div>
                                </div>
                                </Transition>
                            </div>
                        </div>
                </div>

                <div className={`${styles.co_production} co_production ${styles.mobile} ${this.getLanguageClass()}`}>
                    <div className={styles.menu_wrapper}>
                        <div className={styles.menu} onClick={() => {
                            this.props.setMenuVisible(true)
                        }}>
                            <span className={styles.menu_icon}><div className={styles.menu_icon_line}></div></span>
                            <span>OUTLAND File Production</span>
                        </div>
                    </div>
                    <div className={styles.content}>

                        <div className={`production_content_logo ${styles.content_logo}`}>
                            <div
                              className={`${styles.video_player} ${this.state.trailerVideoVisible ? null : 'display_none'}`}>
                                <div className={`close_button ${styles.close_button}`}
                                     onClick={() => {
                                         this.closeVideo()
                                     }}>
                                    <div className="left_line">
                                        <div className="right_line"></div>
                                    </div>
                                </div>

                                {vw < 768 ?
                                  <Player preload="none" ref={player => {
                                      this.player = player;
                                  }}>
                                      <source src={videoMobil}/>
                                      <ControlBar autoHide={false}/>
                                  </Player>
                                  : null }
                            </div>
                            <div className={styles.slide_container}>
                                <Slider {...sliderSetting}>
                                    {this.state.production.images.filter(image=>image.apply).filter(image=>image.type==="desktop").map(image=>{
                                        return <div className={styles.content_slide}>
                                            <div className={styles.img} style={
                                                {
                                                    backgroundImage: `url("${productionBaseUrl + image.path}"`,
                                                    width: this.sliderWidthM,
                                                    height: this.sliderHeightM
                                                }
                                            }></div>
                                        </div>
                                    })}
                                </Slider>
                            </div>
                        </div>
                        <div className={styles.content_container}>
                            <div className={styles.content_overlay}></div>
                            <div className={styles.content_description}>
                                <div className={styles.production_content_container}>
                                    <div className={styles.page}>
                                        <div className={styles.page_subtitle}>{this.state.production.year} · FILM</div>
                                    </div>

                                    <div className={styles.production_content_title} dangerouslySetInnerHTML={{__html: this.state.production.name}}></div>

                                    {this.state.production.videoPath !== null && "" !== this.state.production.videoPath.trim() ?
                                      <div className={styles.production_trailer} onClick={this.handleTrailerVideo}></div>
                                      : null
                                    }

                                    {this.state.production.awards.length > 0 ?
                                    <div className={styles.production_award}>
                                        {this.state.production.awards.map(award => {
                                            return <div><span className={styles.award_icon}></span>{award.content}</div>
                                        })}
                                    </div>
                                      : null }
                                    <div className={styles.production_description}  dangerouslySetInnerHTML={{__html: this.state.production.description}}>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.back_wrapper} onClick={this.goBackToProductionList}>
                                <div className={`arrow left ${styles.arrow}`}></div>
                                <div className={styles.back_word}>BACK</div>
                            </div>
                        </div>
                    </div>
                    {/*<div className={styles.back_wrapper} onClick={this.goBackToProductionList}>*/}
                    {/*    <div className={`arrow left ${styles.arrow}`}></div>*/}
                    {/*    <div className={styles.back_word}>BACK</div>*/}
                    {/*</div>*/}

                </div>

            </>
        );
    }
};

const mapStateToProps = state => {
    return {
        isPageVisible: state.isPageVisible,
        language: state.language
    };
};

export default connect(mapStateToProps, {setMenuVisible})(CoProductionInfo);
